import { render, staticRenderFns } from "./LocatorPoint.vue?vue&type=template&id=8b49ce1a&scoped=true&"
import script from "./LocatorPoint.vue?vue&type=script&lang=js&"
export * from "./LocatorPoint.vue?vue&type=script&lang=js&"
import style0 from "./LocatorPoint.vue?vue&type=style&index=0&id=8b49ce1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b49ce1a",
  null
  
)

export default component.exports